import { SupportedLocales } from 'config';

export interface SupportedLanguage {
  label: string;
  shortLabel: string;
  icon: string;
  locale: SupportedLocales;
  currency: string;
}
export const languages: SupportedLanguage[] = [
  {
    label: 'English',
    shortLabel: 'eng',
    icon: 'twemoji:flag-united-kingdom',
    locale: 'en-US',
    currency: 'USD',
  },
  {
    label: 'Ελληνικά',
    shortLabel: 'gre',
    icon: 'twemoji:flag-greece',
    locale: 'el-GR',
    currency: 'EUR',
  },
];
